import clsx from 'clsx'

export interface ButtonProps extends React.HTMLAttributes<HTMLButtonElement> {}

export const ButtonCounter = ({ children, className, ...rest }: ButtonProps) => {
  return (
    <button
      {...rest}
      className={clsx(
        'h-[40px] cursor-pointer flex items-center justify-center gap-2 pl-3 pr-4 shadow-drop-shadow-2 bg-surface-default rounded-full',
        className,
      )}
    >
      {children}
    </button>
  )
}
